import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import ScrapAgentCard from '@/entities/scrap-agent/scrap-agent-common/card.vue';
import VueCustomScrollbar from 'vue-custom-scrollbar/src/vue-scrollbar.vue';

@Component({
  components: {
    VueCustomScrollbar,
    ScrapAgentCard,
    DsModal,
  },
})
export default class MyComponent extends Vue {
  // Props
  @Prop({ type: Boolean, default: false }) open!: boolean;
  @Prop({ type: Array, required: true }) listChannels!: Array<any>;

  // Data
  showModal = this.open;
  channelByType = 'ALL';
  loadingRegisterChannel = true;
  scrollSettings = { wheelPropagation: false };
  categoryType = [
    { id: 1, label: this.$t('cdHome.t179'), name: 'ALL' },
    // { id: 2, label: 'Goover', name: 'GOOVER' },
    { id: 2, label: this.$t('cdHome.t180'), name: 'CLOUD' },
    { id: 3, label: this.$t('cdHome.t181'), name: 'SOCIAL' },
    { id: 4, label: this.$t('cdHome.t182'), name: 'BLOG' },
    { id: 5, label: this.$t('cdHome.t183'), name: 'RSS' },
    { id: 6, label: this.$t('cdHome.t184'), name: 'EMAIL' },
    { id: 7, label: this.$t('cdHome.t185'), name: 'URL' },
    { id: 8, label: this.$t('cdHome.t186'), name: 'GOOVER' },
  ];

  // Watchers
  @Watch('open')
  onOpenChanged(value: boolean) {
    console.log('show-modal', value);
    this.showModal = value;
    if (value) {
      this.loadingRegisterChannel = true;
    }
    if (this.listChannels.length > 0) {
      this.loadingRegisterChannel = false;
    }
  }

  @Watch('listChannels')
  onListChannels(value: any) {
    if (this.channelByType === 'RSS' || this.channelByType === 'URL') {
      this.loadingRegisterChannel = false;
    } else if (value.length > 0) {
      this.loadingRegisterChannel = false;
    }
  }

  // Methods
  @Emit('show-agent-step2') handleClose() {
    this.showModal = false;
    return true;
  }

  handleChangeCategoryType(type: string) {
    console.log('Clicked Category:', type);

    if (this.channelByType !== type) {
      this.channelByType = type;
      this.loadingRegisterChannel = true;
      this.$emit('search-by-category', type);
    }
  }

  @Emit('handleConnect') handleConnect(item: any) {
    return item;
  }

  @Emit('handleShowUrlForm') handleShowUrlForm() {
    return true;
  }
}
